import React from 'react';
import { FileText, UsersThree } from '@phosphor-icons/react';
import { useOneButtonStore } from '../../../../../store/oneButtonStore';

type ActionTile = {
    id: string;
    label: string;
    hint: string;
    icon: React.ReactNode;
    featured?: boolean;
    disabled?: boolean;
    onClick: () => void;
};

export type DashboardProjectHeaderActionDeckProps = {
    /** Inline in project site ribbon (split header) */
    layout?: 'inline' | 'ribbon';
};

export const DashboardProjectHeaderActionDeck: React.FC<DashboardProjectHeaderActionDeckProps> = ({
    layout = 'inline',
}) => {
    const setDashboardContactsModalOpen = useOneButtonStore((s) => s.setDashboardContactsModalOpen);
    const setCommerceHubQuotesOpen = useOneButtonStore((s) => s.setCommerceHubQuotesOpen);

    const tiles: ActionTile[] = [
        {
            id: 'contacts',
            label: 'Contacts',
            hint: 'People on this job',
            icon: <UsersThree size={13} weight="duotone" aria-hidden />,
            onClick: () => setDashboardContactsModalOpen(true),
        },
        {
            id: 'generate-proposal',
            label: 'Generate Proposal',
            hint: 'Quotes & contracts',
            icon: <FileText size={13} weight="duotone" aria-hidden />,
            featured: true,
            disabled:true,
            onClick: () => setCommerceHubQuotesOpen(true),
        },
    ];

    return (
        <footer
            className={`obd-project-header-action-deck${layout === 'ribbon' ? ' obd-project-header-action-deck--ribbon' : ''}`}
            aria-label="Project shortcuts"
        >
            {layout !== 'ribbon' ? <p className="obd-project-header-action-deck__label">Quick actions</p> : null}
            <div className="obd-project-header-action-deck__stack" role="group">
                {tiles.map((tile) => (
                    <button
                        key={tile.id}
                        type="button"
                        className={`obd-project-header-action-tile${tile.featured && !tile.disabled ? ' obd-project-header-action-tile--featured' : ''}`}
                        data-obd-guide={`project-${tile.id}`}
                        onClick={tile.onClick}
                        disabled={tile.disabled}
                    >
                        <span className="obd-project-header-action-tile__icon-wrap" aria-hidden>
                            {tile.icon}
                        </span>
                        <span className="obd-project-header-action-tile__text">
                            <span className="obd-project-header-action-tile__title">{tile.label}</span>
                            <span className="obd-project-header-action-tile__hint">{tile.hint}</span>
                        </span>
                    </button>
                ))}
            </div>
        </footer>
    );
};

export default DashboardProjectHeaderActionDeck;
